{
  "version": 1,
  "asset_id": "97779c0c-f78b-4953-accd-1e2c3c2a4f6b",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/97779c0c-f78b-4953-accd-1e2c3c2a4f6b/og-audit-defense.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/97779c0c-f78b-4953-accd-1e2c3c2a4f6b/og-audit-defense.jpg",
  "original_filename": "og-audit-defense.jpg",
  "size": 200041,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T16:20:24Z"
}
